export var IntegratedAppStatus;
(function (IntegratedAppStatus) {
    IntegratedAppStatus[IntegratedAppStatus["ACTIVE"] = 1] = "ACTIVE";
    IntegratedAppStatus[IntegratedAppStatus["INACTIVE"] = 2] = "INACTIVE";
})(IntegratedAppStatus || (IntegratedAppStatus = {}));
//# sourceMappingURL=integrated-app-status.js.map